import React from 'react'

export default function TextField(props) {
    const { className, ...rest } = props
    return (
        <input
            className={`w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none text-sm ${className ?? ''}`}
            {...rest}
        />
    )
}
